module.exports = __webpack_public_path__ + "img/bespoke70_00.77b601a9.jpg";